import dayjs from "dayjs";
import { dateFormat } from "us.collection.admin/constants/NonProductionDays";
import { NonProductionDay } from "us.collection.admin/interfaces";

export function AddOrUpdateNonExecutionDay(this: NonProductionDay) {
  const { id, key, dateRange, reason, criteria, isRecurring } = this;
  return {
    id,
    key,
    dateRange: [
      dayjs(
        (dateRange[0] as any)?.toDate
          ? (dateRange[0] as any).toDate()
          : dateRange[0],
      )
        .startOf("day")
        .format(dateFormat),
      dayjs(
        (dateRange[1] as any)?.toDate
          ? (dateRange[1] as any).toDate()
          : dateRange[1],
      )
        .startOf("day")
        .format(dateFormat),
    ],
    reason,
    criteria,
    isRecurring: !!isRecurring,
  };
}
